import React, { useState, useEffect } from 'react';
import { FaBuilding, FaHandshake, FaLeaf, FaUsers, FaUtensils, FaUmbrellaBeach, FaSeedling, FaBroom, FaShip, FaTruck, FaHeart, FaStar, FaGlobe, FaCog, FaLightbulb, FaShieldAlt } from 'react-icons/fa';
import CtaMapSection from './CtaMapSection';
import { API_BASE } from '../config';
import './AboutPage.css';

const iconMap = {
  FaUtensils: <FaUtensils />,
  FaUmbrellaBeach: <FaUmbrellaBeach />,
  FaShip: <FaShip />,
  FaTruck: <FaTruck />,
  FaSeedling: <FaSeedling />,
  FaBroom: <FaBroom />,
  FaBuilding: <FaBuilding />,
  FaHandshake: <FaHandshake />,
  FaLeaf: <FaLeaf />,
  FaUsers: <FaUsers />,
  FaHeart: <FaHeart />,
  FaStar: <FaStar />,
  FaGlobe: <FaGlobe />,
  FaCog: <FaCog />,
  FaLightbulb: <FaLightbulb />,
  FaShieldAlt: <FaShieldAlt />,
};

const defaultData = {
  hero: {
    badge: 'Didim Belediyesi İştiraki',
    title: 'Hakkımızda',
    description: "Didim'in geleceğine değer katmak için çalışıyoruz",
  },
  story: {
    year: '2019',
    title: 'Biz Kimiz?',
    paragraph1: "Dihiz A.Ş., 23 Eylül 2019 tarihinde kurulmuş olup %100 Didim Belediyesi'ne ait bir şirkettir. Şirketimiz, öncelikli olarak yiyecek ağırlıklı kafe ve kafeterya işletmeleriyle Didim halkına ve misafirlerine kaliteli hizmet sunmayı amaçlamaktadır. Misafirlerimizin keyifli vakit geçirebileceği sıcak ve samimi bir ortam yaratırken, yerel lezzetleri ön plana çıkaran zengin menülerimizle gastronomi alanında fark yaratmayı hedefliyoruz.",
    paragraph2: "Dihiz A.Ş., yalnızca yeme-içme hizmetleriyle sınırlı kalmayıp geniş bir faaliyet yelpazesiyle de Didim'in sosyal ve ekonomik gelişimine katkıda bulunmaktadır. Turizm organizasyonu, denizcilik, taşımacılık, gıda, çiçekçilik ve temizlik hizmetleri gibi pek çok farklı sektörde hizmet sunarak bölgenin ihtiyaçlarına kapsamlı çözümler üretmeyi misyon edindik. Her alanda kaliteyi öncelik olarak benimseyen şirketimiz, sürdürülebilirlik ve yenilikçilik anlayışıyla hizmetlerini her geçen gün geliştirmektedir.",
  },
  mission: {
    title: 'Misyonumuz',
    paragraph1: "Belediyemize ait bir kuruluş olmanın bilinciyle hareket eden Dihiz A.Ş., Didim'in marka değerini artırmaya yönelik projelere imza atmayı ilke edinmiştir. Yerel halkın ihtiyaçlarını gözeten, ekonomik kalkınmayı destekleyen ve turizmin canlı kalmasını sağlayan çalışmalarla bölgeye fayda sağlamayı hedeflemekteyiz.",
    paragraph2: "Kafe ve kafeteryalarımızda, lezzetli yiyecek ve içeceklerin yanı sıra güler yüzlü hizmet anlayışıyla konuklarımızın mutlu anlarına eşlik etmekten gurur duyuyoruz. Aynı zamanda denizcilik ve taşımacılık faaliyetlerimizle ulaşımda kolaylık sağlarken, turizm organizasyonlarımızla Didim'in doğal güzelliklerini daha fazla kişiye tanıtıyoruz. Gıda, çiçekçilik ve temizlik hizmetlerimizle ise hem bireysel hem de kurumsal ihtiyaçlara yönelik çözümler sunuyoruz.",
    paragraph3: "Dihiz A.Ş. olarak Didim'in geleceğine değer katmak için var gücümüzle çalışıyoruz. Hem yerel ekonomiyi canlandırmak hem de misafirlerimize en iyi hizmeti sunmak için kendimizi sürekli yeniliyoruz.",
  },
  sectors: {
    subtitle: 'Faaliyet Alanlarımız',
    title: 'Hizmet Verdiğimiz Sektörler',
    items: [
      { icon: 'FaUtensils', title: 'Kafe & Restoran', desc: 'Yiyecek ve içecek hizmetleri' },
      { icon: 'FaUmbrellaBeach', title: 'Turizm Organizasyonu', desc: 'Turizm geliştirme ve yönetim' },
      { icon: 'FaShip', title: 'Denizcilik', desc: 'Deniz ulaşım hizmetleri' },
      { icon: 'FaTruck', title: 'Taşımacılık', desc: 'Lojistik ve taşıma çözümleri' },
      { icon: 'FaSeedling', title: 'Çiçekçilik', desc: 'Peyzaj ve çiçekçilik' },
      { icon: 'FaBroom', title: 'Temizlik', desc: 'Temizlik ve tedarik yönetimi' },
    ],
  },
  values: {
    subtitle: 'Değerlerimiz',
    title: 'Bizi Biz Yapan İlkeler',
    items: [
      { icon: 'FaBuilding', title: 'Kurumsal Güven', desc: '%100 Didim Belediyesi iştiraki olarak şeffaf ve güvenilir yönetim.' },
      { icon: 'FaHandshake', title: 'Kaliteli Hizmet', desc: 'Her alanda en yüksek standartlarda hizmet sunma taahhüdü.' },
      { icon: 'FaLeaf', title: 'Sürdürülebilirlik', desc: 'Çevre dostu ve yenilikçi yaklaşımlarla geleceğe yatırım.' },
      { icon: 'FaUsers', title: 'Toplumsal Fayda', desc: 'Yerel ekonomiyi canlandıran ve bölgeye değer katan projeler.' },
    ],
  },
};

const setMeta = (seo) => {
  if (!seo) return;
  if (seo.metaTitle) document.title = seo.metaTitle;

  const setOrCreate = (attr, attrVal, content) => {
    if (!content) return;
    let el = document.querySelector(`meta[${attr}="${attrVal}"]`);
    if (!el) { el = document.createElement('meta'); el.setAttribute(attr, attrVal); document.head.appendChild(el); }
    el.setAttribute('content', content);
  };

  setOrCreate('name', 'description', seo.metaDescription);
  setOrCreate('name', 'keywords', seo.metaKeywords);
  setOrCreate('property', 'og:title', seo.metaTitle);
  setOrCreate('property', 'og:description', seo.metaDescription);
  if (seo.ogImage) setOrCreate('property', 'og:image', seo.ogImage);
};

const AboutPage = () => {
  const [data, setData] = useState(defaultData);

  useEffect(() => {
    fetch(`${API_BASE}/about`)
      .then(res => res.json())
      .then(apiData => {
        if (apiData && apiData._id) {
          setData(prev => ({
            hero: { ...prev.hero, ...apiData.hero },
            story: { ...prev.story, ...apiData.story },
            mission: { ...prev.mission, ...apiData.mission },
            sectors: {
              ...prev.sectors,
              ...apiData.sectors,
              items: apiData.sectors?.items?.length ? apiData.sectors.items : prev.sectors.items,
            },
            values: {
              ...prev.values,
              ...apiData.values,
              items: apiData.values?.items?.length ? apiData.values.items : prev.values.items,
            },
          }));
          setMeta(apiData.seo);
        }
      })
      .catch(() => {});

    return () => { document.title = 'Dihiz'; };
  }, []);

  const hero = data.hero;
  const story = data.story;
  const mission = data.mission;
  const sectors = data.sectors;
  const values = data.values;

  return (
    <div className="about-page">
      {/* Hero */}
      <section className="about-hero">
        <div className="about-hero-overlay"></div>
        <div className="about-hero-content">
          <span className="about-hero-badge">{hero.badge}</span>
          <h1 className="about-hero-title">{hero.title}</h1>
          <p className="about-hero-desc">{hero.description}</p>
        </div>
      </section>

      {/* Hikaye */}
      <section className="about-story">
        <div className="about-story-container">
          <div className="about-story-badge">
            <span>Kuruluş</span>
            <strong>{story.year}</strong>
          </div>
          <div className="about-story-content">
            <h2>{story.title}</h2>
            {story.paragraph1 && <p>{story.paragraph1}</p>}
            {story.paragraph2 && <p>{story.paragraph2}</p>}
          </div>
        </div>
      </section>

      {/* Misyon */}
      <section className="about-mission">
        <div className="about-mission-container">
          <div className="about-mission-content">
            <h2>{mission.title}</h2>
            {mission.paragraph1 && <p>{mission.paragraph1}</p>}
            {mission.paragraph2 && <p>{mission.paragraph2}</p>}
            {mission.paragraph3 && <p>{mission.paragraph3}</p>}
          </div>
        </div>
      </section>

      {/* Faaliyet Alanları */}
      <section className="about-sectors">
        <div className="about-sectors-container">
          <span className="about-sectors-subtitle">{sectors.subtitle}</span>
          <h2 className="about-sectors-title">{sectors.title}</h2>
          <div className="about-sectors-grid">
            {sectors.items.map((sector, i) => (
              <div className="about-sector-card" key={i}>
                <div className="about-sector-icon">{iconMap[sector.icon] || <FaBuilding />}</div>
                <h3>{sector.title}</h3>
                <p>{sector.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Değerlerimiz */}
      <section className="about-values">
        <div className="about-values-container">
          <span className="about-values-subtitle">{values.subtitle}</span>
          <h2 className="about-values-title">{values.title}</h2>
          <div className="about-values-grid">
            {values.items.map((value, i) => (
              <div className="about-value-card" key={i}>
                <div className="about-value-icon">{iconMap[value.icon] || <FaBuilding />}</div>
                <h3>{value.title}</h3>
                <p>{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA & Harita */}
      <CtaMapSection />
    </div>
  );
};

export default AboutPage;
